import type { KgInsightThemeType } from '@api';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import clsx from 'clsx';

import styles from './ThemeSearchLogo.module.scss';

export interface ThemeSearchLogoProps {
  name: string;
  logoUrl?: string;
  themeType?: KgInsightThemeType;
  size?: 16 | 32;
}

export const ThemeSearchLogo = ({
  name,
  logoUrl,
  themeType,
  size = 32,
}: ThemeSearchLogoProps) => {
  const type = themeType ?? 'industry';
  return (
    <ThemeLogoIcon
      name={name}
      logo_url={logoUrl}
      type={type}
      size={size}
      fallbackIcon={
        <div
          className={clsx(styles.fallback, {
            [styles.small]: size === 16,
            [styles.industry]: type === 'industry',
            [styles.financial]: type === 'financial',
            [styles.macro]: type === 'macro',
          })}
          data-theme-search-logo
          data-theme-type={type}
        >
          {name.charAt(0)}
        </div>
      }
    />
  );
};
